import cx from "classnames"
import type React from "react"
import { Icon } from "../Icon"

export interface TabProps {
  children: React.ReactNode
  url?: string
  selected?: boolean
  inCard?: boolean
}

export const Tab = ({
  children,
  url,
  selected = false,
  inCard = false,
}: TabProps) => {
  const className = cx("cobalt-Tab", {
    "cobalt-Tab--inCard": inCard,
  })
  const tabProps = {
    role: "tab",
    "aria-selected": selected,
    className,
  }

  let TabComponent: React.ElementType
  if (url == null) {
    TabComponent = "button"
  } else {
    TabComponent = "a"
    Object.assign(tabProps, { href: url })
  }

  return (
    <TabComponent {...tabProps}>
      <span className="cobalt-Tab__Content">{children}</span>
    </TabComponent>
  )
}

export interface TabBarProps {
  children: React.ReactNode
  leftAlign?: boolean
  underlined?: boolean
}

export const TabBar = ({
  children,
  leftAlign = false,
  underlined = false,
}: TabBarProps) => {
  const scrollerClassName = cx("cobalt-TabScroller", {
    "cobalt-TabScroller--underlined": underlined,
  })

  const scrollAreaClassName = cx("cobalt-TabScroller__ScrollArea", {
    "cobalt-TabScroller__ScrollArea--leftAlign": leftAlign,
  })

  return (
    <div className="cobalt-TabBar" role="tablist">
      <div className="cobalt-TabBar__ScrollControl">
        <button type="button" className="cobalt-TabBar__ScrollButton">
          <Icon source="chevronLeft" />
        </button>
      </div>
      <div className={scrollerClassName}>
        <div className={scrollAreaClassName}>{children}</div>
      </div>
      <div className="cobalt-TabBar__ScrollControl">
        <button type="button" className="cobalt-TabBar__ScrollButton">
          <Icon source="chevronRight" />
        </button>
      </div>
    </div>
  )
}
